import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  addeditdata,
} from "../../../src/controllers/events/eventsController";
import { fetchIpAddress } from "../../../src/controllers/API";


const SlotsEditPage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);

  const [passwordVisible, setPasswordVisible] = useState(false);

  // const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    vendor_account_number: ADDEDITDATA?.vendor_account_number || "",
  });
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };


  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const {
        _id,
        slot_name,
        slot_date,
        slot_start_time,
        slot_end_time
      } = ADDEDITDATA;
      const ipAddress = await fetchIpAddress();

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("slot", slot_name);
      form.append("date", slot_date);
      form.append("slot_from", slot_start_time);
      form.append("slot_to", slot_end_time);
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);

      const data = {
        edit_id: _id,
        slot: slot_name,
        date: slot_date,
        slot_from: slot_start_time,
        slot_to: slot_end_time,
        ipAddress: ipAddress
      };

      if (isValidate) {
        const options = {
          url: "events/addedit-slots",
          postData: data,
        };
        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated!",
            description: `Data updated successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/events/slots-list");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberPattern = /^[0-9]+$/;
    // const vendor_country_code = formData.get("country_code");

    if (!formData.get("date")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        slot_date: "Slot date is required",
      }));
      return false;
    }
    if (!formData.get("slot")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        slot_name: "Slot is required",
      }));
      return false;
    }
    if (!formData.get("slot_from")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        slot_start_time: "Slot From time is required",
      }));
      return false;
    }
    if (!formData.get("slot_to")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        slot_end_time: "Slot To time is required",
      }));
      return false;
    }
    return true;
  };



  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} SLots
            </h5>
          </div>
          <Link to="/events/slots-list">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="slot_date"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Slot Date :{" "}
                      </label>
                      <input
                        title="Slot date"
                        type="date"
                        name="slot_date"
                        className="form-control store_input_field"
                        id="slot_date"
                        value={ADDEDITDATA?.slot_date}
                        onChange={handleChange}
                      />
                      {error.slot_date ? (
                        <p style={{ color: "red" }}>
                          {error.slot_date}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="slot_name"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Slot :
                      </label>
                      <input
                        title="Enter Slot name"
                        placeholder="Enter Slot name"
                        type="text"
                        name="slot_name"
                        className="form-control store_input_field"
                        id="slot_name"
                        value={ADDEDITDATA?.slot_name}
                        onChange={handleChange}
                      />
                      {error.slot_name ? (
                        <p style={{ color: "red" }}>
                          {error.slot_name}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="slot_start_time"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Slot From Time :{" "}
                      </label>
                      <input
                        title="Slot From Time"
                        placeholder="Slot From Time"
                        type="time"
                        name="slot_start_time"
                        className="form-control store_input_field"
                        id="slot_start_time"
                        value={ADDEDITDATA?.slot_start_time}
                        onChange={handleChange}
                      />
                      {error.slot_start_time ? (
                        <p style={{ color: "red" }}>{error.slot_start_time}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="slot_end_time"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Slot To Time :
                      </label>
                      <input
                        title="Enter Slot To Time."
                        placeholder="Enter Slot To Time."
                        type="time"
                        name="slot_end_time"
                        className="form-control store_input_field"
                        id="slot_end_time"
                        value={ADDEDITDATA?.slot_end_time}
                        onChange={handleChange}
                      />
                      {error.slot_end_time ? (
                        <p style={{ color: "red" }}>{error.slot_end_time}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default SlotsEditPage;
